import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  card: {
    height: 131,
    flex: 1,
    backgroundColor: 'white',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    overflow: 'hidden',
    shadowColor: 'rgba(0,0,0,0.5)',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
    marginTop: 20,
    borderRadius: 12,
    paddingVertical: 10,
  },
  spaceItens: {
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
    marginRight: 8,
    alignItems: 'baseline',
    justifyContent: 'space-between',
  },
    footer: {
    backgroundColor: Colors.RedPallete.red,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: -10,
    elevation: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    width: '100%',
  },
  footerText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
  },
  description: {
    maxWidth: 170,
    textAlign: 'left',
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 16,
    color: 'black',
    marginBottom: 5,
  },
  quantity: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
    marginBottom: 5,
  },
  spaceA: {
    flexShrink: 0,
    alignItems: 'flex-end',
    justifyContent: 'space-around',
  },
  priceText: {
    fontSize: 10,
    lineHeight: 12,
    color: 'black',
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  originalPrice: {
    textDecorationLine: 'line-through',
    color: 'gray',
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  discountedPrice: {
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
});
